jQuery(document).ready(function ($) {
  console.log("JS enabled");

  // ===== Variables globales =====
  const mobileMenu = {
    burger: $(".burger"),
    mobileMenu: $(".mobilemenu"),
    mainPanel: $(".mobilemenu .panel.main-panel"),
    secondaryPanel: $(".mobilemenu .panel.secondary-panel"),
    mainPages: $(".mobilemenu .panel.main-panel .menu-item"),
    backButtons: $(
      ".mobilemenu .panel.secondary-panel button[data-trigger='back']"
    ),
  };

  // ===== Gestion de l'affichage de leads-quickaccess =====
  const leadsQuickaccess = $(".xefi-leads-quickaccess");
  const quickContact = $(".quickcontact");

  // Si quickContact n'existe pas, on affiche toujours leadsQuickaccess
  // Sinon, on le masque au chargement et on le gère au scroll
  if (!quickContact.length) {
    leadsQuickaccess.show();
  } else {
    leadsQuickaccess.hide();
  }

  // ===== Initialisation =====
  function initMobileMenu() {
    // Attacher les gestionnaires d'événements
    attachEventHandlers();
  }

  // ===== Gestionnaires d'événements =====
  function attachEventHandlers() {
    // Clic sur un élément du menu principal
    mobileMenu.mainPages.click(handleMainPageClick);

    // Clic sur le bouton retour (prêt pour l'implémentation future)
    mobileMenu.backButtons.click(handleBackButtonClick);

    // Ouverture/fermeture du menu selon l'état du burger
    mobileMenu.burger.click(function () {
      if ($(this).hasClass("close")) {
        // Si le burger a la classe close, on ferme le menu
        closeMobileMenu();
      } else {
        // Sinon, on ouvre le menu
        openMobileMenu();
      }
    });
  }

  // ===== Fonctions de gestion des événements =====
  function handleMainPageClick() {
    const trigger = $(this).data("trigger");

    // Activer le panel secondaire correspondant
    activateSecondaryPanel(trigger);

    // Faire glisser les panels vers la gauche
    slidePanelsLeft();
  }

  function handleBackButtonClick() {
    // Désactiver tous les panels secondaires
    deactivateAllSecondaryPanels();

    // Faire glisser les panels vers la droite (revenir à l'état initial)
    slidePanelsRight();
  }

  function openMobileMenu() {
    // Fermer les autres éléments mobiles avant d'ouvrir le menu
    $(".mobile-search").removeClass("open");
    $(".mobile-customer").removeClass("open");

    // Ajouter la classe close au burger pour le transformer en croix
    mobileMenu.burger.addClass("close");

    // Afficher le menu mobile
    mobileMenu.mobileMenu.addClass("open");
  }

  function closeMobileMenu() {
    // Retirer la classe close du burger pour le remettre en état initial
    mobileMenu.burger.removeClass("close");

    // Remettre les panels dans leur état initial
    slidePanelsRight();
    deactivateAllSecondaryPanels();

    // Fermer le menu mobile
    mobileMenu.mobileMenu.removeClass("open");
  }

  // ===== Fonctions utilitaires =====
  function activateSecondaryPanel(trigger) {
    // Sélectionner le panel-sub correspondant au data-trigger
    const targetPanel = $(".panel-sub[data-target='" + trigger + "']");

    // Ajouter la classe "active" au panel ciblé
    targetPanel.addClass("active");

    // Retirer la classe active des autres panels
    $(".panel-sub").not(targetPanel).removeClass("active");
  }

  function deactivateAllSecondaryPanels() {
    // Retirer la classe "active" de tous les panels secondaires
    $(".panel-sub").removeClass("active");
  }

  function slidePanelsLeft() {
    // Ajouter la classe "slide-left" aux deux panels pour les décaler vers la gauche
    mobileMenu.mainPanel.addClass("slide-left");
    mobileMenu.secondaryPanel.addClass("slide-left");
  }

  function slidePanelsRight() {
    // Retirer la classe "slide-left" des deux panels pour les ramener à leur position initiale
    mobileMenu.mainPanel.removeClass("slide-left");
    mobileMenu.secondaryPanel.removeClass("slide-left");
  }

  // ===== Initialisation du menu mobile =====
  initMobileMenu();

  // ===== Fonctions pour gérer les éléments mobiles =====
  function closeMobileElements() {
    // Fermer tous les éléments mobiles
    $(".mobile-search").removeClass("open");
    $(".mobile-customer").removeClass("open");
    closeMobileMenu();
  }

  function openMobileSearch() {
    // Fermer les autres éléments avant d'ouvrir la recherche
    closeMobileElements();
    $(".mobile-search").addClass("open");
  }

  function closeMobileSearch() {
    $(".mobile-search").removeClass("open");
  }

  function toggleMobileSearch() {
    if ($(".mobile-search").hasClass("open")) {
      closeMobileSearch();
    } else {
      openMobileSearch();
    }
  }

  function openMobileCustomer() {
    // Fermer les autres éléments avant d'ouvrir l'espace client
    closeMobileElements();
    $(".mobile-customer").addClass("open");
  }

  function closeMobileCustomer() {
    $(".mobile-customer").removeClass("open");
  }

  function toggleMobileCustomer() {
    if ($(".mobile-customer").hasClass("open")) {
      closeMobileCustomer();
    } else {
      openMobileCustomer();
    }
  }

  // ===== Gestion du bouton de recherche mobile =====
  $('[data-trigger="search"]').click(function (e) {
    e.preventDefault();
    toggleMobileSearch();
  });

  // ===== Gestion du bouton espace client mobile =====
  $('[data-trigger="customer"]').click(function (e) {
    e.preventDefault();
    toggleMobileCustomer();
  });

  // ===== Gestion du scroll pour afficher leads-quickaccess =====
  $(window).scroll(function () {
    // On ne gère le scroll que si quickContact existe
    if (quickContact.length) {
      const quickContactOffset = quickContact.offset().top;
      const quickContactHeight = quickContact.outerHeight();
      const scrollPosition = $(window).scrollTop();

      // Si on a scrollé au-delà de quickcontact
      if (scrollPosition > quickContactOffset + quickContactHeight) {
        // Afficher leads-quickaccess avec une animation
        leadsQuickaccess.fadeIn(300);
      } else {
        // Masquer leads-quickaccess avec une animation
        leadsQuickaccess.fadeOut(300);
      }
    }
    // Si quickContact n'existe pas, leadsQuickaccess est déjà visible en permanence
  });

  // ===== Génération du sommaire (Table of Contents) pour les articles =====
  function initTableOfContents() {
    const tocContainer = $(".article-toc");
    const postContent = $(".wp-block-post-content");

    // Vérifier que les deux éléments existent
    if (!tocContainer.length || !postContent.length) return;

    const headings = postContent.find("h2, h3");

    // Si pas de titres, masquer le conteneur
    if (!headings.length) {
      tocContainer.hide();
      return;
    }

    // Créer la liste du sommaire
    const tocList = $('<nav class="toc-nav"><ul class="toc-list"></ul></nav>');
    const list = tocList.find(".toc-list");

    headings.each(function (index) {
      const heading = $(this);
      const headingId = "toc-heading-" + index;
      const headingText = heading.text();
      const headingLevel = heading.prop("tagName").toLowerCase();

      // Ajouter un ID au titre pour le lien ancre
      heading.attr("id", headingId);

      // Créer l'élément de liste
      const listItem = $(
        '<li class="toc-item toc-' +
          headingLevel +
          '">' +
          '<a href="#' +
          headingId +
          '" class="toc-link">' +
          headingText +
          "</a>" +
          "</li>"
      );

      list.append(listItem);
    });

    // Ajouter le sommaire au conteneur
    tocContainer.append(tocList);

    // Gestion du clic sur les liens du sommaire (smooth scroll)
    tocContainer.find(".toc-link").on("click", function (e) {
      e.preventDefault();
      const targetId = $(this).attr("href").substring(1);
      const targetElement = $("#" + targetId);

      if (targetElement.length) {
        $("html, body").animate(
          {
            scrollTop: targetElement.offset().top - 100,
          },
          500,
          "swing"
        );
      }
    });

    // Mise en surbrillance du titre actif au scroll
    $(window).on("scroll", function () {
      const scrollPosition = $(window).scrollTop() + 150;

      headings.each(function (index) {
        const heading = $(this);
        const headingTop = heading.offset().top;
        const headingId = heading.attr("id");

        if (scrollPosition >= headingTop) {
          tocContainer.find(".toc-link").removeClass("active");
          tocContainer
            .find('.toc-link[href="#' + headingId + '"]')
            .addClass("active");
        }
      });
    });
  }

  // Initialiser le sommaire
  initTableOfContents();

  // ===== Empêcher l'affichage des ancres "#..." dans l'URL tout en conservant le défilement =====
  $(".wp-block-button__link").each(function () {
    // Vérifier si le bouton a un href qui commence par "#"
    const href = $(this).attr("href");
    if (href && href.startsWith("#")) {
      // Ajouter un gestionnaire d'événement pour le clic
      $(this).on("click", function (event) {
        // Empêcher le comportement par défaut (navigation vers l'ancre dans l'URL)
        event.preventDefault();

        // Récupérer l'ID de l'ancre sans le #
        const targetId = href.substring(1);

        // Trouver l'élément cible dans le DOM
        const targetElement = $("#" + targetId);

        // Si l'élément existe, faire défiler jusqu'à lui
        if (targetElement.length) {
          $("html, body").animate(
            {
              scrollTop: targetElement.offset().top,
            },
            1000,
            "swing"
          ); // Durée de l'animation en millisecondes
        }
      });
    }
  });
});
